<template>
    <button
        v-bind="$attrs"
        class="link-button"
        :class="{ error, 'icon-button': hasLeading || hasTrailing }"
        :type="type"
        v-on="$listeners"
    >
        <slot name="leading">
            <ds-icon v-if="leadingIcon" :name="leadingIcon" />
        </slot>

        <div v-if="hasLeading || hasTrailing">
            <slot />
        </div>

        <slot v-else />

        <slot name="trailing">
            <ds-icon v-if="trailingIcon" :name="trailingIcon" />
        </slot>
    </button>
</template>

<script>
export default {
    props: {
        error: Boolean,
        leadingIcon: {
            type: String,
            default: '',
        },
        trailingIcon: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
    },

    computed: {
        hasLeading() {
            return this.$slots.leading || this.leadingIcon;
        },

        hasTrailing() {
            return this.$slots.trailing || this.trailingIcon;
        },
    },
};
</script>

<style lang="scss" scoped>
.link-button {
    padding: 0;
    background-color: transparent;
    color: $color-blue;
    --icon-color: currentColor;

    &:hover {
        text-decoration: underline;
    }

    &:active {
        color: $color-navy-800;

        &.error {
            color: $color-red-900;
        }
    }

    &[disabled] {
        color: $color-text-disabled;

        &:hover {
            text-decoration: none;
        }
    }

    &.error {
        color: $color-red;
    }
}
</style>
